import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Button, Text } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import ArrowRight from "@assets/icons/arrow-right.svg";

const TestimonialSection = (props) => {
  return (
    <TailwindWrapper>
      <section className="w-full py-5 container">
        <div className="flex flex-col items-center gap-8 lg:gap-16 lg:flex-row py-3 lg:py-24">
          <div className="w-full flex justify-center items-center">
            <div className="w-full aspect-square bg-gray-100 rounded-xl border border-gray-200 relative overflow-hidden">
              <img
                alt={props.alt || "Hero image"}
                src={props.src || "https://placehold.co/1200x1200"}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full flex flex-col gap-8 justify-between">
            <Text tw variant="text-sm/leading-normal/medium" className="text-[#737373]">
              {props.sectionName}
            </Text>
            <Text tw variant="text-2xl/leading-normal/medium">
              "{props.quote}"
            </Text>
            <div>
              <Text tw variant="text-base/leading-normal/medium">
                {props.contactName}
              </Text>
              <Text tw className="text-[#737373]" variant="text-sm/leading-normal/normal">
                {props.contactProfession}
              </Text>
            </div>
            
            <div className="flex gap-2">
              {props.buttonText && (
                <Button tw variant="outline" onClick={() => window.location.href = props.buttonLink}>
                  {props.buttonText}
                  <ArrowRight width={20} height={20} fill="#0F0F0F"/>
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>
    </TailwindWrapper>
  );
};

TestimonialSection.defaultProps = {
  src: "https://placehold.co/1200x1200",
  alt: "scenic image",
  sectionName: "Testimonial section",
  quote: "Follow with one or two sentences that expand on your value proposition. Focus on key benefits and address why users should take action now. Keep it scannable, direct and benefit-driven.",
  contactName: "David",
  contactProfession: "Skogsägare",
  buttonText: "Learn more",
  buttonLink: "/",
};

TestimonialSection.fields = {
    sectionName: {
      type: "text",
      label: "Testimonial section",
    },
    quote: {
      type: "textarea",
      label: "Beautiful quote from the customer",
    },
    contactName: {
      type: "text",
      label: "Contact Name",
    },
    contactProfession: {
      type: "text",
      label: "Contact Profession",
    },
    buttonText: {
      type: "text",
      label: "Primary Button Text",
    },
    buttonLink: {
      type: "text",
      label: "Primary Button Link",
    },
    src: {
      type: "custom",
      label: "Image Source",
      render: ({ name, onChange, value }) => (
        <MediaSelector
          name={name}
          label="Image Source"
          type={"img"}
          onChange={onChange}
          value={value}
        />
      ),
    },
    alt: {
      type: "text",
      label: "Image Alt Text",
    },
};

export default TestimonialSection;
